var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-video-player"},[(_vm.playInfo.type === 'txy')?_c('video',{style:(_vm.customStyle),attrs:{"id":"txy-player-container","preload":"auto","playsinline":"","webkit-playsinline":""}}):_vm._e(),_c('div',{attrs:{"id":"other-player-container"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb360c22","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/component/video-player/index.vue
// module id = 652
// module chunks = 0 1 2 3